export const LABELS = {
  gbp: '£',
  usd: '$',
  aed: 'AED',
  eur: '€',
  dkk: 'kr.',
  chf: '₣',
  cad: 'CAD',
  sar: 'SAR',
};

export const GBP = {
  iso: 'gbp',
  label: LABELS.gbp,
};

export const USD = {
  iso: 'usd',
  label: LABELS.usd,
};

export const AED = {
  iso: 'aed',
  label: LABELS.aed,
};

export const EUR = {
  iso: 'eur',
  label: LABELS.eur,
};

export const DKK = {
  iso: 'dkk',
  label: LABELS.dkk,
};

export const CHF = {
  iso: 'chf',
  label: LABELS.chf,
};

export const CAD = {
  iso: 'cad',
  label: LABELS.cad,
};

export const SAR = {
  iso: 'sar',
  label: LABELS.sar,
};

export default {
  gb: GBP,
  us: USD,
  ca: CAD,
  ae: AED,
  ch: CHF,
  eu: EUR,
  sa: SAR,
  dk: DKK,

  at: EUR,
  be: EUR,
  de: EUR,
  gr: EUR,
  ie: EUR,
  es: EUR,
  it: EUR,
  cy: EUR,
  lv: EUR,
  lt: EUR,
  lu: EUR,
  mt: EUR,
  nl: EUR,
  pt: EUR,
  sk: EUR,
  sl: EUR,
  fi: EUR,
  fr: EUR,
  ee: EUR,
};
